import type { KeyValueStore } from './types';

export function createMemoryKv(initial: Record<string, string> = {}): KeyValueStore {
  const map = new Map(Object.entries(initial));
  return { get: (k) => map.get(k) ?? null, set: (k, v) => void map.set(k, v), remove: (k) => void map.delete(k) };
}

/** localStorage-backed store; every access is guarded (private windows and blocked storage throw). */
export function createLocalKv(prefix = 'planella:'): KeyValueStore {
  const fallback = createMemoryKv();
  return {
    get(k) { try { return globalThis.localStorage.getItem(prefix + k); } catch { return fallback.get(k); } },
    set(k, v) { try { globalThis.localStorage.setItem(prefix + k, v); } catch { fallback.set(k, v); } },
    remove(k) { try { globalThis.localStorage.removeItem(prefix + k); } catch { fallback.remove(k); } },
  };
}
